import Assets from './Assets';
import Content from './Content';
import Profile from './Profile';
import Meta from './Meta';
import Embed from './Embed';

import _ from 'lodash';
import { assetFromRef } from '../../../utils/asset';

/**
 * DisplayItem > OriginalContent object.
 *
 * @typedef {Object} OriginalContent
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {Object} assets the media properties of the original content
 * @property {Object} content the text and url of the original content
 * @property {Object} embed the embed properties of the original content
 * @property {Object} meta the type, network, and createDate of the original content
 * @property {Object} profile the author properties of the original content
 */

// mirror the structure of DisplayItem for needed properties
class OriginalContent {
  constructor({ author, assets, createDate, displayedUrls, id, itemClass, network, text, url }) {
    this.id = id;
    this.actions = {};
    this.assets = new Assets(
      _.get(assets, '[0].mainAssetRef'),
      _.get(assets, '[0].thumbnailAssetRef'),
      '',
      _.get(assets, '[0].sizes')
    );
    this.content = new Content(
      /*heading*/ '',
      /*byline*/ '',
      text,
      /*contentRendered*/ '',
      /*caption*/ '',
      url,
      '' /* linkTitle */,
      '' /* linkText */,
      displayedUrls
    );
    this.embed = new Embed();
    this.meta = new Meta(
      createDate,
      network,
      itemClass,
      !!_.get(assets, '[0].mainAssetRef') ? assetFromRef(assets[0].mainAssetRef).assetType : 'text'
    );
    this.profile = new Profile(author.id, author.name, author.handle, author.avatarUrl);
  }
}

export default OriginalContent;
